import { PREVIEW_HOST_BASE_URL, previewHostPageUrl } from '../constants/widgetBrands'

// cdn.sh names releases <UTC timestamp>Z-<commit> by default but accepts any
// safe identifier (RELEASE_ID, e.g. rehearsal-1), so the picker does too; the
// host page applies the same rule. `live` and `studio` are the other version
// values and can never name a release here.
export const RELEASE_ID_PATTERN = /^(?!(?:live|studio)$)[A-Za-z0-9][A-Za-z0-9._-]*$/

const HOST_MESSAGE_TYPES = new Set(['ready', 'bundle-failed', 'host-error', 'height', 'betslip', 'cart'])

export function previewHostOrigin(base = PREVIEW_HOST_BASE_URL) {
  try {
    return new URL(base).origin
  } catch {
    return ''
  }
}

// The viewer identity is deliberately not a parameter: it reaches the host by
// postMessage so it never lands in a URL, a referrer or a CDN log.
export function buildPreviewHostUrl({
  base = PREVIEW_HOST_BASE_URL,
  org,
  surface,
  offering,
  release = 'latest',
  api,
  host,
  width,
} = {}) {
  const params = new URLSearchParams({ org, surface })
  if (offering) params.set('offering', offering)
  params.set('release', release || 'latest')
  // Left out, the host page picks the Feed API for its own environment.
  if (api) params.set('api', api)
  if (host) params.set('host', host)
  if (width) params.set('width', String(width))
  return `${previewHostPageUrl(base)}?${params}`
}

export function parsePreviewHostMessage(event, expectedOrigin) {
  if (!expectedOrigin || event?.origin !== expectedOrigin) return null
  const data = event.data
  if (!data || typeof data !== 'object' || !HOST_MESSAGE_TYPES.has(data.type)) return null
  return data
}

// The `version` URL value: live, studio, or a release id (the release picker).
// Anything else is null, so the page can fall back to its default.
export function previewVersionFromSearch(value) {
  if (value === 'live' || value === 'studio') return { kind: value, releaseId: '' }
  if (typeof value === 'string' && RELEASE_ID_PATTERN.test(value)) return { kind: 'release', releaseId: value }
  return null
}

export function previewVersionParam(version) {
  return version.kind === 'release' ? version.releaseId : version.kind
}

function countLabel(count, noun) {
  return `${count} ${noun}${count === 1 ? '' : 's'}`
}

function simulationLine(label, count, noun, couponType) {
  const line = `${label}: ${countLabel(count, noun)}`
  return typeof couponType === 'string' && couponType ? `${line}, ${couponType}` : line
}

// One line for what the host's betting shim received; the host shows the ids.
export function hostActivityNotice(message) {
  if (message?.type === 'betslip') {
    const outcomes = Array.isArray(message.outcomeIds) ? message.outcomeIds.length : 0
    return simulationLine('Betslip simulation', outcomes, 'outcome', message.couponType)
  }
  if (message?.type === 'cart') {
    const items = Array.isArray(message.items) ? message.items.length : 0
    return simulationLine('Cart simulation', items, 'item', message.couponType)
  }
  return ''
}
